package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class SendTicketReplyResponseDto(
    val status: String,
    val ticketId: String,
    val outboundMessageId: String,
    val providerMessageId: String,
    val providerThreadId: String
)

/** Pièce jointe outbound : meta + contenu base64. sizeBytes permet validation/logs sans décoder. */
@Serializable
data class OutboundAttachmentDto(
    val filename: String,
    val mimeType: String,
    val contentBase64: String,
    val sizeBytes: Long,
    val sha256: String? = null
)

@Serializable
data class SendTicketReplyRequestDto(
    val body: String,
    val subject: String? = null,
    val to: String? = null,
    val attachments: List<OutboundAttachmentDto> = emptyList()
)

@Serializable
data class UpdateTicketStatusRequestDto(
    val status: String
)

@Serializable
data class AddMemoryRequestDto(
    val key: String,
    val value: String
)

@Serializable
data class ConfirmKeyRequestDto(
    val key: String
)
